/**
 * Module dependencies.
 */

import { FilterRange } from 'src/types/model-ranges';
import { Radio } from 'src/components/core';
import { ReactElement, ReactNode, useCallback, useMemo } from 'react';
import { units } from '@untile/react-components';
import { useFiltersList } from 'src/context/filters-list/context';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  label: ReactNode;
  name: string;
  value: FilterRange;
};

/**
 * `StyledRadio` styled component.
 */

const StyledRadio = styled(Radio)`
  padding: ${units(1)} 0;
`;

/**
 * `FilterItem` component.
 */

const FilterItem = (props: Props): ReactElement => {
  const { className, label, name, value } = props;
  const { isFilterSelected, onSet } = useFiltersList();
  const handleChange = useCallback(
    event => {
      const { value } = event.target;

      onSet(name, JSON.parse(value));
    },
    [name, onSet]
  );

  const fromToValue = useMemo(
    () => ({
      from: value.from,
      to: value.to
    }),
    [value]
  );

  return (
    <StyledRadio
      checked={isFilterSelected(name, JSON.stringify(fromToValue))}
      className={className}
      label={label}
      name={name}
      onChange={handleChange}
      value={JSON.stringify(fromToValue)}
    />
  );
};

/**
 * Export `FilterItem` component.
 */

export default FilterItem;
